
import { useState, useEffect } from "react";
import { LeadAccount, StrategyWithDetails } from "@/types/strategy-types";

export const useAccountFiltering = (
  userRole: string | null | undefined,
  strategies: StrategyWithDetails[],
  leadAccounts: LeadAccount[]
) => {
  const [filteredStrategies, setFilteredStrategies] = useState<StrategyWithDetails[]>([]);
  const [filteredLeadAccounts, setFilteredLeadAccounts] = useState<LeadAccount[]>([]);

  useEffect(() => {
    // If strategy provider, filter by provider ID
    if (userRole === 'strategy_provider') {
      // Get the first lead account's provider_id to use for filtering
      if (leadAccounts.length > 0) {
        const providerId = leadAccounts[0].strategy_provider_id;
        
        setFilteredStrategies(
          strategies.filter(strategy => strategy.strategy_provider_id === providerId)
        );
        
        setFilteredLeadAccounts(
          leadAccounts.filter(account => account.strategy_provider_id === providerId)
        );
      }
    } else {
      // Admin can see all
      setFilteredStrategies(strategies);
      setFilteredLeadAccounts(leadAccounts);
    }
  }, [userRole, strategies, leadAccounts]);

  return {
    filteredStrategies,
    filteredLeadAccounts
  };
};
